import React from "react"

import { ArrowLeft, ChevronLeft, ChevronRight } from "lucide-react"
import { useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { useAdjacentApplications } from "@/hooks/useAdjacentApplications"

interface ApplicantActionsProps {
  navigateTo: string
  applicationId?: string
  currentStage?: string | null
  hideBackButton?: boolean
}

const ApplicantActions = ({
  navigateTo,
  applicationId,
  currentStage,
  hideBackButton = false,
}: ApplicantActionsProps) => {
  const navigate = useNavigate()

  // Only fetch adjacent applications if we have an application ID and stage
  const { data: adjacentApplications, isLoading } = useAdjacentApplications(
    applicationId,
    currentStage,
  )

  const handlePreviousClick = () => {
    if (adjacentApplications?.previousApplicationId) {
      navigate(`/applications/${adjacentApplications.previousApplicationId}`)
    }
  }

  const handleNextClick = () => {
    if (adjacentApplications?.nextApplicationId) {
      navigate(`/applications/${adjacentApplications.nextApplicationId}`)
    }
  }

  if (hideBackButton) {
    // Only show Next/Previous buttons
    return (
      <>
        {applicationId && currentStage && (
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handlePreviousClick}
              disabled={isLoading || !adjacentApplications?.previousApplicationId}
              title="Previous application in this stage"
            >
              <ChevronLeft className="h-4 w-4 mr-1" />
              Previous
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={handleNextClick}
              disabled={isLoading || !adjacentApplications?.nextApplicationId}
              title="Next application in this stage"
            >
              Next
              <ChevronRight className="h-4 w-4 ml-1" />
            </Button>
          </div>
        )}
      </>
    )
  }

  return (
    <div className="flex items-center justify-between mb-4">
      <Button
        variant="ghost"
        className="flex items-center gap-2"
        onClick={() => navigate(navigateTo)}
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Applications
      </Button>

      {applicationId && currentStage && (
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={handlePreviousClick}
            disabled={isLoading || !adjacentApplications?.previousApplicationId}
            title="Previous application in this stage"
          >
            <ChevronLeft className="h-4 w-4 mr-1" />
            Previous
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={handleNextClick}
            disabled={isLoading || !adjacentApplications?.nextApplicationId}
            title="Next application in this stage"
          >
            Next
            <ChevronRight className="h-4 w-4 ml-1" />
          </Button>
        </div>
      )}
    </div>
  )
}

export default ApplicantActions
